import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useRef, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { updateProductStockListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { publicImageProps } from "../../services/config";
import ProductFilter from "./ProductFilter";
import { digitsThree } from "../../utils/price";
import DefaultImage from "../../components/common/default-image/DefaultImage";
import UpdateProductStockModal from "./sub-components/update-product-stock-list/update-product-stock-modal/UpadateProductStockModal";

export default function UpdateProductStockList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [productData, setProductData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getProduct = async (params) => {
    const path = "admin/products";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setProductData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getProduct({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getProduct(allFilter);
  };

  const data = [];

  productData?.map((item) => {
    const showDiscountPercent = item.option?.variations?.find(
      (i) => i.discountPercent
    )
      ? "آپشن تخفیف دارد"
      : `${item.discountPercent}%`;
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      basePrice: `${digitsThree(item.basePrice)}`,
      showDiscountPercent: showDiscountPercent,
      faInventoryStatus:
        item.inventoryStatus == "available" ? "موجود" : "نا موجود",
      showMainImage: item.mainImage ? (
        <img
          className="w-10 h-10 rounded-md"
          {...publicImageProps(item.mainImage, { variant: "thumb_" })}
        />
      ) : (
        <DefaultImage imgSize={26} imgClass={"!w-10 !h-10 rounded-md"} />
      ),
      createdAt: item.createdAt,
      faStatus:
        item.status === "active"
          ? "فعال"
          : item.status === "pending"
          ? "انتظار"
          : "غیرفعال",
    });
  });

  const updateStockModalRef = useRef(null);

  const handleUpdateStock = (singleProduct) => {
    const newSingleProduct = productData.filter((item) => {
      return item._id == singleProduct.id;
    });
    updateStockModalRef.current.showModal(newSingleProduct[0]);
  };

  return (
    <>
      <UpdateProductStockModal
        ref={updateStockModalRef}
        reGetData={getProduct}
      />
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title title={"آپدیت موجودی محصولات"} />
        <ProductFilter filterDataHandler={filterDataHandler} />
        <Pagination
          filterDataHandler={filterDataHandler}
          pagination={pagination}
        />
        <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry}
          columns={updateProductStockListColumns}
          rows={data}
          onCustomFunction={handleUpdateStock}
          customFunctionName="آپدیت موجودی"
        />

        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
      </div>
    </>
  );
}
